import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '@one-thd/sui-atomic-components';
import { UsedProductCard } from './UsedProductCard';

export const UsedProductGrid = memo(function UsedProductGrid({
  items,
  onQuickViewClick,
  loading,
}) {
  if (loading) {
    return (
      <div
        className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 md:sui-grid-cols-3 xl:sui-grid-cols-4 sui-gap-6"
        aria-busy="true"
      >
        {Array.from({ length: 8 }).map((unused, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index}>
            <Skeleton variant="rectangular" height={200} />
            <Skeleton variant="text" className="sui-mt-2" />
            <Skeleton variant="text" width="60%" />
          </div>
        ))}
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <p className="sui-text-center sui-text-subtle sui-py-8">No products found.</p>
    );
  }

  return (
    <section
      className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 md:sui-grid-cols-3 xl:sui-grid-cols-4 sui-gap-6"
      aria-label="Product results"
    >
      {items.map((item, index) => (
        <UsedProductCard
          // eslint-disable-next-line react/no-array-index-key
          key={`${item.StrNbr}-${item.CategoryCd}-${item.SubCategoryCd}-${index}`}
          item={item}
          onQuickViewClick={onQuickViewClick}
        />
      ))}
    </section>
  );
});

UsedProductGrid.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onQuickViewClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

UsedProductGrid.defaultProps = {
  loading: false,
};
